import {
  Box, Grid, Paper, Typography,
} from '@material-ui/core';
import type { AxiosError } from 'axios';
import axios from 'axios';
import * as React from 'react';
import useSWR from 'swr';
import { useSnackbar } from 'notistack';
import { useAuthContext } from '../auth/AuthContext';
import getEmployeeLevels from '../lib/SWRfetchers/getEmployeeLevels';

interface GetEmployeeDto {
  employeeId:string;
  firstName: string;
  lastName: string;
  email: string;
  barcode: string;
  phone: string;
  employeeLevels: number[];
  isActive: boolean;
  isLocked: boolean;
  assignedRepairs: number;
  assignedLocation: string;
}

const Home: React.FC = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { user } = useAuthContext();
  const { employeeLevels } = getEmployeeLevels();
  const userEmail = user?.email ?? '';

  const [employeeSelectedLevels, setEmployeeSelectedLevels] = React.useState<number[]>([]);

  const highestUserLevel = employeeLevels ? employeeLevels.map(
    (employeeLevel) => {
      if (employeeSelectedLevels.sort((a, b) => a - b)[0] === employeeLevel.value) {
        return employeeLevel.label;
      }
      return '';
    },
  ) : '';

  const [employeeInfo, setEmployeeInfo] = React.useState({
    employeeId: '',
    firstName: '',
    lastName: '',
    email: '',
    barcode: '',
    phoneNumber: '',
    isActive: true,
    isLocked: false,
    assignedRepairs: 0,
    assignedLocation: '',
  });

  const userFetcher = (url: string, emailParam: string) => axios.get<GetEmployeeDto>(url, {
    params: {
      userEmail: emailParam,
    },
  })
    .then((response) => {
      setEmployeeSelectedLevels([...response.data.employeeLevels]);
      setEmployeeInfo({
        employeeId: response.data.employeeId,
        firstName: response.data.firstName,
        lastName: response.data.lastName,
        email: response.data.email,
        barcode: response.data.barcode,
        phoneNumber: response.data.phone,
        isActive: response.data.isActive,
        isLocked: response.data.isLocked,
        assignedRepairs: response.data.assignedRepairs,
        assignedLocation: response.data.assignedLocation,
      });
      return response.data;
    })
    .catch((e: AxiosError) => {
      enqueueSnackbar(`There was the following error when fetching the user: ${JSON.stringify(e?.response?.data)}`, { persist: false, variant: 'error' });
    });

  const { data } = useSWR(
    userEmail
      ? ['/EmployeeInfo/GetEmployee', userEmail]
      : null,
    (url, emailParam) => userFetcher(url, emailParam), {
      revalidateOnFocus: false,
      revalidateOnMount: true,
      revalidateOnReconnect: false,
      refreshWhenOffline: false,
      refreshWhenHidden: false,
      refreshInterval: 0,
    },
  );

  return (
    <Grid container spacing={0} alignItems="stretch">
      <Grid item xs={9} container spacing={3} alignItems="stretch">
        <Grid item xs={12}>
          <Paper>
            <Grid container spacing={3} alignItems="stretch">
              <Grid item xs={10}>
                {
                  userEmail && data ? (
                    <>
                      <Box pl={2} pt={1} clone>
                        {/* -1 for employeeSelectedLevels because employeeRoles starts at index of 1 and not 0 */}
                        <Typography variant="caption">{highestUserLevel}</Typography>
                      </Box>
                      <Box pl={2} pt={1} clone>
                        <Typography variant="h5">{`Welcome, ${employeeInfo.firstName} ${employeeInfo.lastName}!`}</Typography>
                      </Box>
                    </>
                  ) : (
                    <Box pl={2} pt={1} clone>
                      <Typography variant="h5">{'Welcome, User!'}</Typography>
                    </Box>
                  )
                }
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Home;
